// 全局过滤器
/*      
function trim(str)                      删除左边空格 
function parseTime(str,cFormat)         时间格式化
function formatNuber(val)               保留小数2位
function formatMoney(val)               格式货币
*/
export function trim(str) {
	return str.replace(/(^\s*)|(\s*$)/g, '');
}


/*
time: 时间戳
cFormat：需要格式的类型： '{y}-{m}-{d} {h}:{i}:{s}' ||  {y}-{m}-{d}
*/
export function parseTime(time, cFormat) {
    if (!arguments || arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
    }

    if (!date) {
        return null
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

/*
time: 时间戳
fmt：需要格式的类型： 'YYYY-mm-dd HH:MM:SS' 注意大小写，月份和日期是小写
*/
export function parseTimeNew(time, fmt) {
    if (arguments.length === 0) {
        return null
    }
    let ret;
    let date = new Date(time)
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}
/*
time: 时间戳
fmt：需要格式的类型： 'YYYY-mm-dd HH:MM:SS' 注意大小写，月份和日期是小写
*/
export function dateMMDD(time) {
  if (time) {
    let date = new Date(parseInt(time));
    return `${(date.getMonth() + 1).toString()}月${date.getDate().toString()}日`
  }else{
    return null
  }
}
export function formatNuber(val) {
    let valNumber = Number(val)
    return valNumber==0?'0.00':valNumber.toFixed(2)
}

export function formatMoney (s, n) {
    if (s) {
        n = n > 0 && n <= 20 ? n : 2
        s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
        let l = s
            .split('.')[0]
            .split('')
            .reverse()
        let r = s.split('.')[1]
        let t = ''
        let len = l.length
        for (let i = 0; i < len; i++) {
            t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '')
        }
        return (
            t
                .split('')
                .reverse()
                .join('') +
            '.' +
            r
        )
    } else {
        return '0.00'
    }
}

// 分割金额：这里只返回小数点后面的值
export function SplitMoney  (data) {
    if(data){
        let pointCount =  data.toString().split('.')
        return pointCount[1] ? '.'+pointCount[1]: '.00'
    }else{
        return '.00'
    }
}

// 分割数量：万为单位
export function wan  (data) {
    if(data && data.toString().length>4){
        let pointCount = data.toString().substring(0,data.toString().length-4)
        return pointCount+'万'
    }else{
        return data
    }
}
